import { useCallback } from 'react'
import styled from '@emotion/styled'
import Card from '../../components/common/Card'
import Text from '../../components/common/Text'
import Button from '../../components/common/Button'
import FooterContent from '../../components/FooterContent'
import Image from '../../components/common/Image'
import IconSuccess from '../../assets/images/infographic-reward-success.svg'
import { numberWithCommas, useRouter } from '../../utils/helper'
import { mobile, useScreen } from '../../utils/responsive-helper'
import { useHistory } from 'react-router'
import { FONT_BLACK } from '../../constant/colors'
import { enrollment } from '../../constant/path'

const Column = styled.div`
  display: flex;
  flex-direction: column;
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
`

const RowCenter = styled(Row)`
  text-align: center;
  justify-content: center;
`

const RowSpaceBetween = styled(Row)`
  margin-top: 24px;
  justify-content: space-between;
`

const LayoutImage = styled(RowCenter)`
  width: 100%;
  height: 430px;

  ${mobile} {
    height: 343px;
  }
`

const LayoutCard = styled(Card)`
  padding: 32px;
  margin-bottom: 80px;

  ${mobile} {
    padding: 16px;
    margin-bottom: 40px;
  }
`

const PaddingText = styled.div`
  padding-top: 8px;
`

const PaddingImage = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
`

const TextNotWrap = styled(Text)`
  white-space: nowrap;
`

const MarginTop = styled.div`
  margin-top: 64px;

  ${mobile} {
    margin-top: 24px;
  }
`

const ButtonStyle = styled(Button)`
  width: 267px;
`

const EClaimComplete = () => {
  const { eClaimName, eClaimPrice } = useRouter().query
  const { isMobile } = useScreen()
  const history = useHistory()
  const onClickBackToEnrollment = useCallback(() => {
    history.push(enrollment())
  }, [history])

  return (
    <>
      <Column>
        <MarginTop />
        <RowCenter>
          <Text size={26} type={'Bold'} color={FONT_BLACK}>
            {' '}
            ส่งเรื่องเบิกเรียบร้อยแล้ว{' '}
          </Text>
        </RowCenter>
        <PaddingText>
          <RowCenter>
            <Text size={20} type={'Medium'} color={FONT_BLACK}>
              {' '}
              รอเจ้าหน้าที่ตรวจสอบ เมื่ออนุมัติ เงินจะเข้าบัญชีเงินเดือน{' '}
            </Text>
            <Text size={20} type={'Bold'} color={FONT_BLACK}>
              &nbsp;ภายใน 30 วัน{' '}
            </Text>
          </RowCenter>
        </PaddingText>
        <PaddingImage>
          <LayoutImage>
            <Image src={IconSuccess} />
          </LayoutImage>
        </PaddingImage>
        <LayoutCard>
          <Column>
            <Row>
              <Text size={24} type={'Bold'} color={FONT_BLACK}>
                รายละเอียดสวัสดิการที่ยื่นคำขอ{' '}
              </Text>
            </Row>
            <RowSpaceBetween>
              <Text size={20} type={'Medium'} color={FONT_BLACK}>
                {eClaimName}
              </Text>
              <TextNotWrap size={20} type={'Bold'} color={FONT_BLACK}>
                {numberWithCommas(eClaimPrice)} บาท
              </TextNotWrap>
            </RowSpaceBetween>
          </Column>
        </LayoutCard>
      </Column>
      <FooterContent
        style={{
          height: 80,
          display: 'flex',
          justifyContent: isMobile ? 'center' : 'flex-end',
          alignItems: 'center',
        }}
      >
        {<ButtonStyle onClick={onClickBackToEnrollment}>กลับไปหน้าแรก</ButtonStyle>}
      </FooterContent>
    </>
  )
}

export default EClaimComplete
